<!-- Contenido por paso -->
<div class="creditos365-body">

  <!-- PASO 1: Datos personales -->
  @if (currentStep === 1) {
  <div class="step-container">
    <!-- <!-<h2 class="step-title">{{ sesion.nameSession }}, completa tus datos personales</h2> -->
    <h2 class="step-title">Para continuar con la aplicación, completa la siguiente información.</h2>
    <p class="step-subtitle">Ten en cuenta que quedará registrado en la plataforma de nuestro aliado.</p>

    <!-- Formulario paso 1 -->
    <form [formGroup]="form.controls.step1">

      <!-- Fila 1: Fecha de nacimiento - Fecha de expedición -->
      <div class="form-row">
        <div class="form-field">
          <label for="birthDate">Fecha de nacimiento:*</label>
          <div class="input-with-icon">
            <input type="text" class="input" id="birthDate" placeholder="AAAA/MM/DD" formControlName="birthDate"
              [matDatepicker]="picker" [max]="maxDate" (input)="formatBirthDateInput($event)" maxlength="10">
            <mat-datepicker-toggle class="date-icon" [for]="picker">
              <mat-icon matDatepickerToggleIcon>
                <img src="assets/images/modals/calendario1.svg" width="24" height="24" alt="calendario">
              </mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </div>
        </div>
        <div class="form-field">
          <label for="expeditionDate">Fecha de expedición del documento:*</label>
          <div class="input-with-icon">
            <input type="text" class="input" id="expeditionDate" placeholder="AAAA/MM/DD"
              formControlName="expeditionDate" [matDatepicker]="picker2" [max]="today" maxlength="10">
            <mat-datepicker-toggle class="date-icon" [for]="picker2">
              <mat-icon matDatepickerToggleIcon>
                <img src="assets/images/modals/calendario1.svg" width="24" height="24" alt="calendario">
              </mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </div>
        </div>
      </div>

      <!-- Fila 2: Departamento - Ciudad -->
      <div class="form-row">
        <div class="form-field">
          <label for="department">Departamento:*</label>
          <app-custom-select [listItems]="departments" [placeholder]="'Selecciona tu departamento'"
            [selectItem]="{ label: form.controls.step1.controls.department.value, value: form.controls.step1.controls.department.value }"
            (selectItemEvent)="setDepartment($event)">
          </app-custom-select>
        </div>
        <div class="form-field">
          <label for="city">Ciudad:*</label>
          <app-custom-select [listItems]="listCitiesByDepartment" [placeholder]="'Selecciona tu ciudad'"
            [selectItem]="{ label: form.controls.step1.controls.city.value, value: form.controls.step1.controls.city.value }"
            (selectItemEvent)="setCity($event)">
          </app-custom-select>
        </div>
      </div>

      <!-- Fila 3: Barrio-Zona -->
      <div class="form-row">
        <div class="form-field">
          <label for="neighborhood">Barrio:*</label>
          <input type="text" class="input" id="neighborhood" placeholder="Ingresa el barrio donde vives"
            formControlName="neighborhood">
        </div>
        <div class="form-field">
          <label for="zone">Zona:*</label>
          <app-custom-select [listItems]="zones" [placeholder]="'Selecciona tu zona'" [selectItem]="selectZone"
            [preventDeleteKeys]="true" (selectItemEvent)="setZone($event)">
          </app-custom-select>
        </div>
      </div>

      <!-- Fila 4: Dirección - Género -->
      <div class="form-row">
        <div class="form-field">
          <label for="address">Dirección:*</label>
          <input type="text" class="input" id="address" placeholder="Ingresa tu dirección de residencia"
            formControlName="address">
        </div>
        <div class="form-field">
          <label>Género:*</label>
          <div class="gender-buttons">
            <button type="button" class="btn-gender" [class.active]="form.controls.step1.controls.gender.value === 'F'"
              (click)="setGender('F')">Femenino</button>
            <button type="button" class="btn-gender" [class.active]="form.controls.step1.controls.gender.value === 'M'"
              (click)="setGender('M')">Masculino</button>
          </div>
        </div>
      </div>

      <!-- Nivel académico (columna izquierda) -->
      <div class="form-row">
        <div class="form-field col-left">
          <label>Nivel académico:*</label>
          <app-custom-select [listItems]="listAcademicLevel" [placeholder]="'Selecciona tu nivel académico'"
            [selectItem]="selectAcademicLevel" [preventDeleteKeys]="true" [preventNumberKeys]="true"
            (selectItemEvent)="setAcademicLevel($event)">
          </app-custom-select>
        </div>
      </div>

      <!-- Sección contacto adicional -->
      <section>
        <h3 class="section-title">Necesitamos un contacto adicional</h3>

        <!-- Fila: Parentesco - Número de contacto -->
        <div class="form-row">
          <div class="form-field">
            <label>¿Quién es tu contacto adicional?:*</label>
            <app-custom-select [listItems]="listAdditionalContact" [placeholder]="'Quién es'"
              [selectItem]="selectAdditionalContact" [preventDeleteKeys]="true"
              (selectItemEvent)="setAdditionalContact($event)">
            </app-custom-select>
          </div>
          <div class="form-field">
            <label for="numberContact">Número de contacto:*</label>
            <input type="tel" class="input" id="numberContact" placeholder="Número de contacto"
              formControlName="numberContact" maxlength="11" inputmode="numeric" (input)="onNumberContactInput($event)">
          </div>
        </div>
      </section>

    </form>

    <div class="step-actions">
      <button class="btn-cancelar-link" (click)="cancel()">Cancelar<i class="fa fa-chevron-right"></i></button>
      <button class="btn-siguiente" (click)="nextStep()" [disabled]="!canContinueStep1">Continuar <i
          class="fa fa-chevron-right"></i></button>
    </div>
  </div>
  }

  <!-- PASO 2: Datos laborales / financieros -->
  @if (currentStep === 2) {
  <div class="step-container">
    <h2 class="step-title">Para continuar con la aplicación, completa la siguiente información.</h2>
    <p class="step-subtitle">Ten en cuenta que quedará registrado en la plataforma de nuestro aliado.</p>

    <!-- Formulario paso 2 -->
    <form [formGroup]="form.controls.step2">

      <!-- Fila 1: Monto - Ingresos -->
      <div class="form-row">
        <div class="form-field">
          <label for="amount">¿Qué monto necesitas?:*</label>
          <input type="text" class="input" id="amount" placeholder="$0 COP"
            [value]="amountControl.value !== null ? (amountControl.value | number:'1.0-0':'es-CO') : ''"
            inputmode="numeric" (input)="onAmountInput($event)" (blur)="onCreditAmountBlur()">
          <div class="col-12 min-max-texts">
            <span class="left-range">Min: <span>$100.000</span></span>
            <span class="right-range">Max: <span>$1.500.000</span></span>
          </div>
          @if (amountControl.touched && amountControl.invalid) {
          <p class="field-error">
            @if (amountControl.errors?.['required']) {
            El monto solicitado es obligatorio.
            } @else {
            El monto debe estar entre $100.000 y $1.500.000.
            }
          </p>
          }
        </div>
        <div class="form-field">
          <label for="income">Ingresos:*</label>
          <input type="text" class="input" id="income" placeholder="$0 COP"
            [value]="incomeControl.value !== null ? (incomeControl.value | number:'1.0-0':'es-CO') : ''"
            inputmode="numeric" (input)="onIncomeInput($event)" (blur)="onIncomeBlur()">
          @if (incomeControl.touched && incomeControl.invalid) {
          <p class="field-error">
            @if (incomeControl.errors?.['required']) {
            El ingreso es obligatorio.
            } @else {
            El ingreso debe ser un numero mayor a 0.
            }
          </p>
          }
        </div>
      </div>

      <!-- Fila 2: Ocupación -->
      <div class="form-row">
        <div class="form-field col-left">
          <label>Ocupación:*</label>
          <app-custom-select [listItems]="listOccupation" [placeholder]="'Selecciona tu Ocupación'"
            [selectItem]="selectOccupation" [preventDeleteKeys]="true" (selectItemEvent)="setOccupation($event)">
          </app-custom-select>
        </div>
      </div>

      <!-- Sección información bancaria -->
      <section>
        <h3 class="section-title">Confirma tu información bancaria</h3>

        <!-- Fila: Banco - Tipo de cuenta -->
        <div class="form-row">
          <div class="form-field">
            <label>Selecciona tu banco:*</label>
            <app-custom-select [listItems]="listBanks" [placeholder]="'Selecciona tu Banco'"
              [selectItem]="selectYourBank" [preventDeleteKeys]="true" (selectItemEvent)="setSelectYourBank($event)">
            </app-custom-select>
          </div>
          <div class="form-field">
            <label>Tipo de cuenta:*</label>
            <app-custom-select [listItems]="listAccountType" [placeholder]="'Elige el tipo de cuenta'"
              [selectItem]="selectAccountType" [preventDeleteKeys]="true" (selectItemEvent)="setAccountType($event)">
            </app-custom-select>
          </div>
        </div>

        <!-- Fila: Número de cuenta -->
        <div class="form-row">
          <div class="form-field col-left">
            <label for="accountNumber">Número de cuenta:*</label>
            <input type="text" class="input" id="accountNumber" placeholder="Número de cuenta"
              formControlName="accountNumber" inputmode="numeric" (input)="onAccountNumberInput($event)">
            @if (accountNumberLength > 0) {
            <span class="input-counter">Llevas {{ accountNumberLength }} dígitos.</span>
            }
          </div>
        </div>
      </section>

      <!-- Términos y condiciones -->
      <div class="terms-acceptance">
        <label class="terms-label">
          <input type="checkbox" formControlName="allyTermsAccepted">
          <span>He leído y acepto los <a href="https://credito365.co/terms/" target="_blank"
              rel="noopener noreferrer">Términos y Condiciones</a> y la <a href="https://credito365.co/privacy-policy/"
              target="_blank" rel="noopener noreferrer">Política de Tratamiento de datos Personales</a> de Tech365
            SAS.</span>
        </label>
      </div>

    </form>
    <div class="step-actions">
      <button class="btn-atras" (click)="prevStep()"><i class="fa fa-chevron-left"></i> Cancelar</button>
      <button class="btn-siguiente" (click)="nextStep(); confirmRequest()" [disabled]="!canContinueStep2">Aplicar oferta
        <i class="fa fa-chevron-right"></i></button>
    </div>
  </div>
  }

  <!-- PASO 3: Resultado de la solicitud -->
  @if (currentStep === 3) {
  <div class="step-container">

    @if (showResult && resultSuccess) {
    <h2 class="step-title">¡Felicitaciones, {{ sesion.nameSession }}!</h2>
    <p class="step-subtitle">Tu solicitud ha sido recibida con éxito por {{offer.offerSelected.company.name}},
      ahora te enviaremos a la
      <strong>web del aliado</strong> a continuar la
      <strong>validación de identidad</strong> y el <strong>desembolso</strong>.
    </p>
    <div class="step-actions">
      <button class="btn-confirmar" (click)="goDisbursement()">
        Ir al desembolso <i class="fa fa-chevron-right"></i>
      </button>
    </div>
    }
  </div>
  }
</div>